import Typography from "@mui/material/Typography";
import RelativeTime from "../../RelativeTime.tsx";

/** When the queues were last counted (every five minutes). */
export default function SampledAt({ at }: { at: string | null }) {
  return (
    <Typography variant="caption" sx={{ color: "text.secondary" }}>
      {at ? (
        <>
          Sampled <RelativeTime value={at} />
        </>
      ) : (
        "Not sampled yet"
      )}
    </Typography>
  );
}
